export default __webpack_public_path__ + "static/media/jungle_3.f838d2fc.jpg";